import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../../lib/hoc/withModal';
import CsInquiryQuestionModal from '../../../../../views/cs/inquiry/common/modal/CsInquiryQuestionModal';
import { csInquiryActions } from '../../../../../store/modules/cs/inquiry';

class CsInquiryQuestionModalContainer extends Component {
  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    this.props.toggleModal({
      name: ['csInquiryQuestionModal'],
      isOpen: false,
      data: {},
    });
  };

  render() {
    return <CsInquiryQuestionModal {...this.state} {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.csInquiry.csInquiryQuestionModal.isOpen,
    data: state.csInquiry.csInquiryQuestionModal.data,
  };
};

const mapDispatchToProps = {
  openCsInquiryQuestionModal: csInquiryActions.openCsInquiryQuestionModal,
  setData: csInquiryActions.setData,
  toggleModal: csInquiryActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(CsInquiryQuestionModalContainer));
